import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  minHeight: 21.5,
  marginBottom: 0.5,
  width: '100%',
  gap: 0.5,
  flexWrap: 'nowrap',
  overflow: 'hidden',
};
